import React from 'react'
import { AddToBoard as AddToBoardCore } from '@ztechapps/board.webui'
import { TriggerComponent } from './TriggerComponent'
import { ItemInfoComponent } from './ItemInfoComponent'
import { AddItemModalContent } from './AddItemModalContent'
import { AddBoardModalContent } from './AddBoardModalContent'

export default function AddToBoard({ product }) {
  return (
    <AddToBoardCore
      entity={product}
      triggerComponent={TriggerComponent}
      itemInfoComponent={ItemInfoComponent}
      addItemContent={<AddItemModalContent />}
      addBoardContent={<AddBoardModalContent />}
    />
  )
}
